import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
const { WizSpin, WizCard, WizForm } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/coach/look') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('coachLook', record)
        } else {
            record = Session.get('coachLook') || {}
        }
    }
    return record
}

class CoachLook extends WizContainer {

    componentName = 'CoachLook'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record
        }
    }

    render() {
        let { counselingProcessLoading } = this.props
        let { record } = this.state
        let columns = [{
            name: 'id',
            dataIndex: 'id',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '辅导日期',
            name: 'tutorDate',
            dataIndex: 'tutorDate',
            formItem: {
                type: 'custom',
                render: (r, f) => r.tutorDate || ''
            }
        }, {
            title: '辅导报告',
            name: 'tutorFileId',
            dataIndex: 'tutorFileId',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    let url = r && r.tutorFileId ? getOssFilePath(r.tutorFileId) : ''
                    let fileName = r && r.tutorFileInfo && r.tutorFileInfo.fileName ? r.tutorFileInfo.fileName : ''
                    return <a href={url} style={{ color: '#1890ff' }}>{fileName}</a>
                }
            }
        }, {
            title: '后续承诺卡',
            name: 'promiseFileIdList',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    let promiseFileIdList = r && r.promiseFileIdList ? r.promiseFileIdList : []
                    let imgs = promiseFileIdList.map((fileId, index) => getOssFilePath(fileId))
                    return (
                        <div style={{ display: 'flex', 'flex-wrap': 'wrap' }}>
                            {imgs.map((img, index) => {
                                return (
                                    <div key={'callCarImg_' + index} style={{ padding: 8 }}>
                                        <img height={80} width={80} src={img} />
                                    </div>
                                )
                            })}
                        </div>
                    )
                }
            }
        }, {
            title: '整改计划',
            name: 'reformFileId',
            dataIndex: 'reformFileId',
            formItem: {
                type: 'custom',
                render: (r, f) => {
                    let url = r && r.reformFileId ? getOssFilePath(r.reformFileId) : ''
                    let fileName = r && r.reformFileInfo && r.reformFileInfo.fileName ? r.reformFileInfo.fileName : ''
                    return <a href={url} style={{ color: '#1890ff' }}>{fileName}</a>
                }
            }
        }]
        let formProps = {
            ref: 'form',
            columns,
            record: record,
            preview: null,
            footer: false,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title='查看辅导'>
                    <WizForm {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        ...loading
    }
}

export default connect(mapStateToProps)(CoachLook)


